
import { Delimiter, Price } from '@ds'
import { CardInfo, getCDNUrl, LAST_SPIRAL_BORDER_DEF_IDS, usePaymentOrder } from '@shared'
import { AppLanguage, StoreItem } from '@store'

import { Button } from '../Button'
import styles from './PaymentPopup.module.scss'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface PopupProps {
  item: StoreItem
  onClose: () => void
}


export const PaymentPopup = ({ onClose, item }: PopupProps) => {
  const { purchaseForXTR, purchaseForTON } = usePaymentOrder()
  const { i18n } = useTranslation()

  const quantity = (item.prices.quantity as number | undefined) ?? 1

  const price = Math.round(item.prices['XTR'] * quantity)
  const cardInfo = useMemo(() => {
    const description = i18n.language === AppLanguage.RU ?
      item.description_ru || item.description
      : item.description
    return {
      url: getCDNUrl(item.image_url),
      description: description,
      effects: {
        mask: false,
        skipRarityTag: LAST_SPIRAL_BORDER_DEF_IDS.includes(item.id), 
        diamondColor: LAST_SPIRAL_BORDER_DEF_IDS.includes(item.id) ? "rgba(115, 0, 255, 1)" : undefined
      },
      rarity: LAST_SPIRAL_BORDER_DEF_IDS.includes(item.id) ? 2 : undefined
    }
  }, [item.image_url])

  return (
    <CardInfo
      url={cardInfo.url}
      effects={cardInfo.effects}
      onClose={onClose}
      title={item.name}
      rarity={cardInfo.rarity}
      description={cardInfo.description}
    >
      <div className={styles.buttons}>
        <Button
          icon="crypto"
          onClick={() => {
            onClose()
            purchaseForTON(item.id, quantity)
          }}
          className={styles.button}
          contentWithShadow={
            <>
              <Delimiter />
              30% off
            </>
          }
        >
          Buy via crypto
        </Button>
        <Button
          icon="buy"
          onClick={() => {
            onClose()
            purchaseForXTR(item.id, quantity)
          }}
          className={styles.button}
        >
          Buy for
          <Price
            value={price}
            className={styles.price}
          />
        </Button>
      </div>
    </CardInfo>
  )
}
